export const debt = {
  list: {
    title: {
      credit_line: 'Liste des lignes de crédit',
    },
    columns: {
      name: 'Nom',
      type: 'Type',
      lender_company: 'Société Prêteur',
      borrowing_company: 'Société Emprunteur',
      currency: 'Devise',
      amount: 'Montant',
      available_amount: 'Montant disponible',
      state: 'Etat',
      start_date: 'Date début',
      end_date: 'Date fin',
    },
    buttons: {
      delete: 'Supprimer',
      addTirage: 'Nouveau tirage',
      btn_paiement: 'Paiement des échéances',
    },
  },
  detail: {
    drawer: {
      title: "Détail de l'échéance",
      card_payement: 'Paiement',
      champ_titles: {
        state: 'Etat',
        timeline: 'Echéance',
        start_date: 'Date Début',
        end_date: 'Date Fin',
        payment_date: 'Date Paiement',
        timeline_date: 'Date Echéance',
        capital_amount_paid: 'Montant Capital versé ou remboursé',
        capital: 'Montant Capital',
        interests_amount: 'Montant Intérêt',
        capital_interests: 'Génération',
        flow: 'Flux',
        compte_mere: 'Compte société Mère',
        compte_fils: 'Compte Société Fille',
      },
      buttons: {
        save_continue: 'Valider - Suivant',
      },
    },
    modal: {
      title: 'Nouveau',
      change_date: 'Modifier la date de la première échéance',
      alert:
        "Voulez-vous ajouter une échéance après l'échéance sélectionnée. Toutes les échéances suivantes seront décalées",
      buttons: {
        yes: 'oui',
        no: 'non',
      },
    },
    columns: {
      timeline_number: 'N° Ech.',
      period: 'Période',
      description: 'Description',
      number_day: 'Nb Jour',
      timeline_date: 'Date Echéance',
      payment_date: 'Date Paiement',
      capital: 'Capital',
      k_movement: 'Mouvement K',
      interests: 'Intérêts',
      accumulated_interest: 'Cumul Intérêts',
      remaining_capital: 'Capital Restant',
      due_amount: 'Echéance',
      state: 'Etat',
    },
    title: "Visualisation de l'échéancier {{name}}",
    titleCalculInt: 'Calcul des intérêts',
    msgCalcul: 'Etes-vous sûr de vouloir lancer le calcul des intérêts',
    buttons: {
      add: 'Ajouter',
      calculInteret: 'Calcul Echéances',
      calculEchues: 'Calcul des échéances non échues',
      calculEcheances: 'Calcul de toutes les échéances',
      mes1: 'Etes-vous sûr de vouloir lancer le calcul des échéances Non échues',
      mes2: 'Etes-vous sûr de vouloir lancer le calcul des TOUTES les échéances',
      mes3: 'Etes-vous sûr de vouloir remplacer TOUTES vos échéances par le  fichier selectionné',
      mes4: '{{errorMessage}}\n Souhaitez vous continuer tout de même',
    },
  },
  fiche: {
    title: {
      timeline: {
        new: "Création d'une nouvelle échéance",
        edit: 'Fiche du Code {{name}}',
        renew: "Renouvellement de l'objet Dette {{name}}",
      },
      echeance: {
        new: "Création d'une nouvelle échéance",
        edit: '{{name}}',
      },
      credit_line: {
        new: "Création d'une nouvelle ligne de crédit",
        edit: 'Fiche de la ligne de credit {{name}}',
      },
      characteristic: 'Caractéristiques',
      interest_management: 'Gestion des intérêts',
      rate_management: 'Gestion du taux',
      capital_amortization: 'Amortissement du Capital',
      forecast_management: 'Gestion des prévisions',
      mail_alert: 'Alerte Mail',
      readonly: 'Lecture seul',
      doc: 'Documents',
    },
    buttons: {
      add: 'Ajouter',
      validate: 'Valider',
      close: 'Annuler',
      join: 'Joindre',
    },
    modal: {
      title: {
        rate: 'Sélection des Taux',
        edit_rate: 'Modification du lien du taux',
        doc: 'Document',
        confirm_evt: "Voulez-vous générer l'évènement de versement",
        confirm_pymt: 'Voulez-vous payer ces échéances',
      },
      columns: {
        margin: 'Marge/Taux',
        base: 'Base',
        fixe_variable: 'Fixe/Var',
      },
      champ_titles: {
        start_date: 'Date de début',
        end_date: 'Date de fin',
        doc_type: 'Type de document',
        doc_name: 'Nom Document',
        state: 'Etat',
        pdf_doc: 'Document PDF',
      },
    },
    columns: {
      margin: 'Marge',
      date: 'Date',
      doc_name: 'Nom Document',
      doc_type: 'Type Document',
      state: 'Etat',
      visualization: 'Visuslaisation',
    },
    champ_titles: {
      type: 'Type',
      name: 'Nom',
      start_date: 'Date Début',
      end_date: 'Date Fin',
      first_maturity_date: 'Date 1ere Echéance',
      amount: 'Montant',
      rate: 'Taux',
      break: 'Rompu',
      interests: 'Intérêts',
      period: 'Génération',
      debit_nature: 'Nature débit',
      credit_nature: 'Nature crédit',
      commission: 'Commission',
      borrowing_company: 'Société emprunteur',
      lender_company: 'Société prêteur',
      state: 'Etat',
      currency: 'Devise',
      flow: 'Flux',
      child_account: 'Compte Société Fille',
      parent_account: 'Compte société Mère',
      emails: 'Emails',
      liquidity: 'Liquidité',
      without_amort: 'Sans amortissement',
      with_amort: 'Avec amortissement',
      interest_calculation_mode: "Méthode de calcul d'intérêt",
    },
    placeholder: {
      flow: '<Paiement hors flux Opencash>',
    },
    alert: {
      break_change:
        "La première date d'échéance sera automatiquement définie en fonction du nouveau rompu choisi",
    },
  },
  payement: {
    payed: 'Payer les échéances',
    icne: 'Calcul des ICNE',
    titleSelectDate: 'Selection de la date',
    date: 'Date :',
    column: {
      tirage_name: 'Tirage',
      credit_line_name: 'Ligne de credit',
      num: 'N°',
      periode: 'Période',
      nbrJ: 'Nb Jour',
      dateEch: 'Date Echéancier',
      dateP: 'Date Paiement',
      capital: 'Capital',
      echeance: 'Echéance',
      interet: 'Intérêts',
      mouvement: 'Mouvement K',
      capitalRest: 'Capital Restant',
      cumulRes: 'Cumul Restant',
      cumulInt: 'Cumul Intérêts',
      status: 'Etat',
    },
  },
  emprunt: {
    titlecreation: "Création d'une nouvelle emprunt",
    edit: "Fiche d'un emprunt  {{name}}",
    title: 'Liste des Emprunts',
    newTirage: 'Nouvel échéancier',
    capital: 'Capital',
  },
  placement: {
    compteTitre: {
      title: 'Liste des comptes titres ',
      lender_company: 'Etablissement financier ',
      borrowing_company: 'Société ',
      valeur: 'Valeur',
      titleDrawer: "Ajout d'une nouvelle Valeur",
      titleEdit: "Modification d'une nouvelle Valeur",
      visualisation: {
        title: 'Visualisation du rélévé de compte titre {{name}}',
        column: {
          label: 'Libellé',
          quantite: 'Quantité',
          date_v: 'Date de valeur',
          cours: 'Cours/Cours achat moyens',
          amount: 'Montant',
          position: 'Position',
          value: '+/- Value',
          devise: 'Devise',
        },
        drawer: {
          title: "Création d'un nouveau mouvement",
          edit: "Modification d'un mouvement ",

          achat: 'Achat',
          vente: 'Vente',
          dateOperation: "Date d'opération",
          dateValeur: 'Date de valeur',
          prix: 'Prix',
          messQuantite: 'Veuillez saisir le montant ou la quantité.',
          quantite: 'Quantité',
          montantT: 'Montant total',
          erreur_msg: 'Quantité en stock disponible : {{quantiteMax}}',
        },
      },
    },
    fiche: {
      title: 'Fiche du Compte titre',
      payementManagement: 'Gestion des Paiements',
      etabFinance: 'Etablissement financier',
      emprunteur: 'Société ',
      compteEtablissement: 'Compte établissement',
      compteSocieté: 'Compte société',
    },
    compteTerme: {
      title: 'Liste des comptes à terme ',
      ficheTitle: 'Fiche du comptes à terme',
      payment: 'Paiement',
      timeline: 'Gestion échéance',
      generate_event: 'Générer Evènement',
      message: 'Voulez-vous générer les évènements',
      renew: 'Renouveler',
    },
  },
  consultation: {
    title: 'Consultation des échéances',
    titlePlct: 'Consultation des placements',
    column: {
      timeline_name: 'Échéancier',
      company_code: 'Société',
      start_date: 'Début',
      end_date: 'Fin',
      counterpart: 'Contrepartie',
      society: 'Société',
      market_room: 'Salle de marché',
      intermediare: 'Intermédiaire',
      directing_rate: 'Taux',
      rate_margin: 'Marge',
      calculation_base: 'Base',
      rate_type: 'Type Taux',
      f_capital: 'Frequence capital',
      depreciation_type: 'Type amortissement',
      f_interest: 'Frequence intérêt',
      nominal: 'Nominal',
      amount: 'Montant',
      next_due_date: 'Prochaine échéance',
      interest: 'Intérêt',
      icne: 'Intérêts courus',
      depreciated_capital: 'Capital amorti',
      period: 'Période',
      price: 'Cours achat',
      quantity: 'Quantité',
      value: '+/- Latente',
      last_rate: 'Cours actuel',
      nbJr: 'N° jours',
      nbJrICNE: 'Nb jour courus',
      nbJrCome: 'Nb Jour à venir',
      nbJrICNECome: 'Intérêts à venir',
      periode: 'Période calcul',
      nbJour: 'Nb jour',
      date_interet: 'Date Intérêt',
    },
  },
  analyse_plct: {
    title: 'Analyse des placements',
    period_1: 'Période de référence 1',
    period_2: 'Période de référence 2',
    column: {
      return: 'Rendement',
      net_change: 'Mouvements nets',
      period_1: 'Période 1',
      period_2: 'Période 2',
    },
  },
  value_gestion: {
    table: {
      title: 'Liste des valeurs',
      button_chargement_cours: 'Chargement Cours',
      columns: {
        status: 'Etat',
        type: 'Type',
        code: 'Code ISN',
        mnemonic: 'Mnémonique',
        lastrate: 'Dernier Cours',
        ratedate: 'Date Cours',
        favorite: 'Favoris',
      },
    },
    fiche: {
      title_new: "Ajout d'une nouvelle valeur",
      title_edit: "Fiche d'une nouvelle valeur : {{code}}",
      first_card_title: 'Général',
      code_isin: 'Code ISIN',
      code_nemonic: 'Mnémonique',
      name: 'Nom',
      second_card_title: 'Caractéristique',
      type: 'Type',
      place_cotation: 'Place de Cotation',
      third_tilte: 'Audit',
      date_creation: 'Date Création',
      date_modif: 'Date Modification ',
    },
    visualise: {
      table: {
        title: 'Cours de la valeur',
        rate: 'Cours',
        date: 'Date Cours',
      },
      modal: {
        title: "Ajout d'un cours",
      },
    },
    chargement: {
      table: {
        title: 'Liste des valeurs',
        column: {
          rate: 'Cours',
          date: 'Date de Modification',
          code: 'Code',
          type: 'Type',
          name: 'Nom',
        },
      },
      modal: {
        title: "Ajout d'un cours",
        date: 'Date de mise à jour ',
      },
    },
  },
  analyse_dept: {
    title: 'Analyse Dette',
    placement_etab: 'Dette par  établissement financiers',
    repartition_type: 'Répartition par type',
    placement_societe: 'Dette par société',
  },
}
